import React from "react";
import { Route, Redirect } from "react-router-dom";
import InstallEmployee from "./InstallEmployee";
import SystemEmployee from "./SystemEmployee";
const Router = ({ match }) => {
  return (
    <React.Fragment>
      <Route
        path={`${match.path}`}
        exact
        render={() => (
          <Redirect to={`${match.path}/installemployee`}></Redirect>
        )}
      ></Route>
      <Route
        path={`${match.path}/installemployee`}
        component={InstallEmployee}
      ></Route>
      <Route
        path={`${match.path}/systememployee`}
        component={SystemEmployee}
      ></Route>
    </React.Fragment>
  );
};
export default Router;
